import { PERMISSIONS } from 'api/auth/constants';
import { PERMISSION_TYPE } from 'hooks/useRBAC';
import { ENTITY } from 'routes/pages/AuthorizedStack/UserManual/helpers';

export enum MANUAL_COMPONENT {
  SECTION = 'sub-section.sub-section',
  TABLE = 'content.table',
}

export interface IManualContent {
  accessType?: PERMISSION_TYPE;
  description: string;
  id: number;
  media: IManualMedia[];
  permissions?: PERMISSIONS[];
  subTitle: string;
  title: string;
  type: MANUAL_COMPONENT;
}

export interface IManualImage {
  alternativeText: string;
  caption: string;
  createdAt: string;
  ext: string;
  folderPath: string;
  formats: string;
  hash: string;
  height: number;
  id: number;
  mime: string;
  name: string;
  previewUrl: string;
  provider: string;
  provider_metadata: string;
  size: number;
  updatedAt: string;
  url: string;
  width: number;
}

export interface IManualMedia {
  description: string;
  id: number;
  image?: IManualImage;
}

export interface IManualSection {
  configuration: IManualSectionConfiguration;
  content: (IManualContent | IManualTable)[];
  createdAt: string;
  id: number;
  locale: string;
  publishedAt: string;
  title: string;
  updatedAt: string;
}

export interface IManualSectionConfiguration {
  accessType?: PERMISSION_TYPE;
  icon?: IManualImage;
  id: number;
  permissions?: PERMISSIONS[];
  sectionType?: ENTITY;
}

export interface IManualTable {
  accessType?: PERMISSION_TYPE;
  id: number;
  permissions?: PERMISSIONS[];
  rows: ITableRow[];
  type: MANUAL_COMPONENT;
}

export interface ITableRow {
  columns: { id: number; text: string }[];
  id: number;
}

export interface IUserManual {
  pagination: {
    page: number;
    pageCount: number;
    pageSize: number;
    total: number;
  };
  sections: IManualSection[];
}
